import type { ServiceType } from "./types";

// Tjänster som är pausade på sajten: tjänstesidorna, menyerna, valet i /boka
// och boknings-API:t. Koden och innehållet ligger kvar, och UK-admin/Neuric
// kan fortfarande boka dem. Öppna igen: töm listorna här och ta bort de
// tillfälliga omdirigeringarna i next.config.ts ("Pausade tjänster").
// Möbelmontering pausad 2026-09-25.
export const HIDDEN_SERVICE_TYPES: readonly ServiceType[] = ["montering"];

/** `serviceCategory` på config-sidorna (lib/config/types.ts). */
export const HIDDEN_SERVICE_CATEGORIES: readonly string[] = ["möbelmontering"];

/** Länkar i header, footer och tjänstemenyn som ska döljas. */
const HIDDEN_HREFS = new Set(["/mobelmontering", "/en/furniture-assembly"]);

export function isServiceTypeHidden(type: string): boolean {
  return (HIDDEN_SERVICE_TYPES as readonly string[]).includes(type);
}

export function isServiceCategoryHidden(category: string): boolean {
  return HIDDEN_SERVICE_CATEGORIES.includes(category);
}

export function isHrefHidden(href: string): boolean {
  return HIDDEN_HREFS.has(href);
}
